import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { registerServiceWorker } from "./register-service-worker";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("PWA root element is missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
